export const Brands: { [host: string]: string } = {
  'localhost:4200': 'Financial Insight',
  'app.pfiverify.com': 'PFI Verify',
  'app.stage.pfiverify.com': 'PFI Verify',
  'app.financeify.co': 'Financeify',
  'app.stage.financeify.co': 'Financeify',
  'app.financeify.com': 'Financeify',
  'app.stage.financeify.com': 'Financeify',
  'app.verifyfinancialprofile.com': 'Verify Financial Profile',
  'app.stage.verifyfinancialprofile.com': 'Verify Financial Profile',
  'app.getpfiverify.com': 'Get PFI Verify',
  'app.stage.getpfiverify.com': 'Get PFI Verify',
  'app.getfinanceify.com': 'Get Financeify',
  'app.stage.getfinanceify.com': 'Get Financeify',
  'app.finsightsai.com': 'Finsights',
  'app.stage.finsightsai.com': 'Finsights',
  'app.pfisimplify.com': 'PFI Simplify',
  'app.stage.pfisimplify.com': 'PFI Simplify',
  'app.financialinsightai.com': 'Financial Insight',
  'app.stage.financialinsightai.com': 'Financial Insight',
};

export interface IHideForBrand {
  hide: boolean;
}
